export const HOME = "/";
export const WELCOME = "/welcome";
export const ABOUT = "/about";
export const WORK_WorkExperience = "/work-experience";
export const PROJECTS = "/projects";
export const SKILLS = "/skills";
export const CONTACT = "/contact";
export const LEGAL_NOTICE = "/legal-notice";
export const UNSERE_TIERE = "/unsere-tiere";
export const PISTACHIO_HOUSE = "/pistachio-house";

